
import { authApi } from '@/utilities/axios';
import { toValue } from 'vue';


export function userCompanyPreference() {
    function fetchCompanyPreference(companyId) {

        const company = toValue(companyId)

        // console.log('companyId', companyId)
        // console.log('company', company)

        const url = `/v2/admin/companies/preference/${company}`

        return authApi
            .get(url)
            .then((response) => {
                    //console.log('userCompanyPreference::fetchData', response)
                    return response.data
                }
            )
    }

    return {
        fetchCompanyPreference,
    }
}